import { downloadFile, generateBlob } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getParticipantsList, getParticipantListDownloadFile } from '../../services/participants'
import { validatePurchaseOrderArrayRules } from '../../modules/utils/actions'
import { ORGANIZATION_CODE_NOT_ALLOWED_ERROR_MESSAGE } from '../../config/settings/constants'
import { batch } from 'react-redux'

export const GET_PARTICIPANTS_LIST_INFO = 'GET_PARTICIPANTS_LIST_INFO'
export const GET_PARTICIPANTS_LIST_ERROR = 'GET_PARTICIPANTS_LIST_ERROR'
export const GET_PARTICIPANTS_LIST_SUCCESS = 'GET_PARTICIPANTS_LIST'
export const onGetParticipantsListInfo = makeActionCreator(GET_PARTICIPANTS_LIST_INFO)
export const onGetParticipantsListError = makeActionCreator(GET_PARTICIPANTS_LIST_ERROR, 'payload')
export const onGetParticipantsListSuccess = makeActionCreator(GET_PARTICIPANTS_LIST_SUCCESS, 'payload')

export const onGetParticipantsListThunk =
  ({ processNumber: numeroProceso, fromWhere: etapaProcesoDesde, onSuccessCallBack }) =>
  async dispatch => {
    dispatch(onGetParticipantsListInfo())
    try {
      const {
        data: {
          payload: { listaFuncion: roleList, listaParticipante: participantList }
        }
      } = await getParticipantsList({
        fields: { numeroProceso, etapaProcesoDesde },
        actionType: GET_PARTICIPANTS_LIST_INFO
      })

      if (participantList && participantList.length === 0) {
        const payload = {
          participants: [],
          participantsValidated: [],
          roleList: []
        }
        return batch(() => {
          dispatch(onGetParticipantsListSuccess(payload))
          if (onSuccessCallBack) onSuccessCallBack()
        })
      }

      const {
        activo: active,
        detalleParticipanteDTO: participantDetailDTO,
        fechaCreacion: creationDate,
        numeroMp: externalCode,
        participanteId: participantId
      } = participantList[0]

      const roleListProcessed = roleList.map(
        ({ activo: active, descripcion: description, funcionId: functionId, nombre: name }) => ({
          active,
          description,
          functionId,
          name
        })
      )

      const dataProcessed = participantDetailDTO.map(
        ({
          activo: activeParticipantDetailDTO,
          cargo: role,
          detalleParticipanteid: participantDetailId,
          email,
          entCode,
          fechaActualizacion: dateUpdate,
          fechaCreacion: creationDate,
          nombreApellido: fullName,
          orgCode,
          participanteId: participantIdDTO,
          procesoParticipante: participantProcess,
          rut: dni,
          esExtranjero: isForeignPerson,
          esResgistroManual: isManual,
          ocultarDetalle: hideDetail,
          fechaInicio: startDate,
          fechaFin: endDate
        }) => ({
          active: activeParticipantDetailDTO,
          fullName,
          role,
          participantDetailId,
          email,
          entCode,
          dateUpdate,
          creationDate,
          orgCode,
          participantId: participantIdDTO,
          participantProcess: {
            participantProcessId: participantProcess.procesoParticipanteId,
            participantDetailId: participantProcess.detalleParticipanteId,
            processId: participantProcess.procesoId,
            functionId: participantProcess.funcionId,
            processNumber: participantProcess.numeroProceso,
            participantDetail: participantProcess.detalleParticipante,
            process: {
              processId: participantProcess.proceso.procesoId,
              name: participantProcess.proceso.nombre,
              groupName: participantProcess.proceso.nombreGrupo,
              active: participantProcess.proceso.activo,
              participantProcessLink: participantProcess.proceso.enlaceProceso
            },
            function: {
              functionId: participantProcess.funcion.funcionId,
              name: participantProcess.funcion.nombre,
              shortName: participantProcess.funcion.nombreCorto,
              description: participantProcess.funcion.descripcion,
              active: participantProcess.funcion.activo
            }
          },
          dni,
          isForeignPerson,
          isManual,
          hideDetail,
          startDate,
          endDate
        })
      )
      const participantListValidated = validatePurchaseOrderArrayRules(dataProcessed)
      const payload = {
        active,
        participants: dataProcessed,
        participantsValidated: participantListValidated,
        creationDate,
        externalCode,
        participantId,
        roleList: roleListProcessed
      }
      return batch(() => {
        dispatch(onGetParticipantsListSuccess(payload))
        if (onSuccessCallBack) onSuccessCallBack(participantId)
      })
    } catch (error) {
      const {
        originalError: {
          response: {
            data: { errores: errorList }
          }
        }
      } = error
      const payload = { errorOrgCodeValidation: false }
      if (errorList && errorList.length > 0) {
        const errorOrgCodeValidation = errorList.some(serverError =>
          ORGANIZATION_CODE_NOT_ALLOWED_ERROR_MESSAGE.includes(serverError.descripcion)
        )
        payload.errorOrgCodeValidation = errorOrgCodeValidation
      }
      return dispatch(onGetParticipantsListError(payload))
    }
  }

export const GET_PARTICIPANTS_LIST_DOWNLOAD_FILE = 'GET_PARTICIPANTS_LIST_DOWNLOAD_FILE'
export const GET_PARTICIPANTS_LIST_DOWNLOAD_FILE_ERROR = 'GET_PARTICIPANTS_LIST_DOWNLOAD_FILE_ERROR'
export const GET_PARTICIPANTS_LIST_DOWNLOAD_FILE_SUCCESS = 'GET_PARTICIPANTS_LIST_DOWNLOAD_FILE_SUCCESS'

export const onGetParticipantsListDownloadFile = makeActionCreator(GET_PARTICIPANTS_LIST_DOWNLOAD_FILE, 'payload')
export const onGetParticipantsListDownloadFileError = makeActionCreator(
  GET_PARTICIPANTS_LIST_DOWNLOAD_FILE_ERROR,
  'payload'
)
export const onGetParticipantsListDownloadFileSuccess = makeActionCreator(
  GET_PARTICIPANTS_LIST_DOWNLOAD_FILE_SUCCESS,
  'payload'
)

export const onGetParticipantsListDownloadFileThunk = externalCode => async dispatch => {
  dispatch(onGetParticipantsListDownloadFile())
  try {
    const fileName = 'listado-participantes'
    const { data, headers } = await getParticipantListDownloadFile({
      externalCode,
      actionType: GET_PARTICIPANTS_LIST_DOWNLOAD_FILE
    })
    const blob = generateBlob(data, headers['content-type'])
    downloadFile(blob, fileName)
    return dispatch(onGetParticipantsListDownloadFileSuccess())
  } catch (error) {
    return dispatch(onGetParticipantsListDownloadFileError({ error }))
  }
}
